import { Link } from 'react-router-dom';
import { useDocumentMeta } from '@/hooks/useDocumentMeta';

export default function NotFound() {
  useDocumentMeta({
    title: '页面不存在 - 大雷影视',
    description: '你访问的页面不存在，可返回大雷影视首页继续浏览最新电影与电视剧。',
  });

  return (
    <div className="mx-auto flex w-full max-w-[1440px] flex-col items-center justify-center px-4 py-24 text-center md:px-8 md:py-32">
      <p className="font-label text-7xl font-semibold leading-none tracking-tight text-background-300 md:text-9xl">404</p>
      <h1 className="mt-6 text-2xl font-bold tracking-tight text-foreground-950 md:text-3xl">这个页面走丢了</h1>
      <p className="mt-3 max-w-md text-sm leading-relaxed text-foreground-500">
        链接可能已经失效，或者地址输入有误。回到首页，继续找一部今晚想看的片子。
      </p>
      <div className="mt-8 flex flex-wrap items-center justify-center gap-3">
        <Link
          to="/"
          className="inline-flex cursor-pointer items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
        >
          <i className="ri-home-5-line" />
          返回首页
        </Link>
        <Link
          to="/category/hot"
          className="inline-flex cursor-pointer items-center gap-2 whitespace-nowrap rounded-md border border-background-300 px-5 py-2.5 text-sm text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-600"
        >
          浏览热门影视
        </Link>
      </div>
    </div>
  );
}